import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Table } from "semantic-ui-react";
import UiMeet3dEventNotification from "~/models/UiMeet3d/UiMeet3dEventNotification";
import UiMeet3dEventNotificationType from "~/constants/UiMeet3d/UiMeet3dEventNotificationType";

const UiMeet3dEventNotificationItem = observer(({ uiMeet3dEventNotification, t }) => {
  let typeName;

  switch (uiMeet3dEventNotification.type) {
    case UiMeet3dEventNotificationType.EMAIL:
      typeName = t("clientPanelMisc:eventNotificationTypeEmail");
      break;
    case UiMeet3dEventNotificationType.SMS:
      typeName = t("clientPanelMisc:eventNotificationTypeSms");
      break;
    default:
      typeName = t("clientPanelMisc:eventNotificationTypeWebhook");
      break;
  }

  return (
    <Table definition>
      <Table.Body>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:method")}</Table.Cell>
          <Table.Cell>{typeName}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell width={4}>{t("clientPanelMisc:recipient")}</Table.Cell>
          <Table.Cell>{uiMeet3dEventNotification.recipient}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
});

UiMeet3dEventNotificationItem.propTypes = {
  t: PropTypes.func.isRequired,
  uiMeet3dEventNotification: PropTypes.instanceOf(UiMeet3dEventNotification),
};

export default withTranslation()(UiMeet3dEventNotificationItem);
